import CampaignIcon from '@mui/icons-material/Campaign';
// eslint-disable-next-line no-restricted-imports
import { templateIcons } from '../features/alerts/components/AlertFab/types';
export function getAlertIcon(icon) {
    if (icon && icon in templateIcons) {
        return templateIcons[icon].icon;
    }
    else {
        return CampaignIcon;
    }
}
